import { gql } from '@apollo/client';

export const SH_NOTIFICATION_FRAGMENT = gql`
  fragment ShNotificationFields on _SH_Notification {
    id
    audience
    structureId
    sportType
    eventType
    entityType
    entityId
    secondaryEntityId
    actorType
    actorId
    actionType
    payload
    payloadVersion
    isRead
    readAt
    expiresAt
    createdAt
    updatedAt
  }
`;

export const SH_PUBLIC_PLAYER_NOTIFICATION_FRAGMENT = gql`
  fragment ShPublicPlayerNotificationFields on _SH_PublicPlayerNotification {
    id
    structureId
    sportType
    eventType
    entityType
    entityId
    actionType
    payload
    isRead
    readAt
    createdAt
  }
`;

export const GET_SH_NOTIFICATIONS = gql`
  query GetShNotifications($groupKey: _SH_NotificationGroupKey, $page: Int, $limit: Int) {
    MDB {
      id
      _SH_ {
        id
        notifications(groupKey: $groupKey, page: $page, limit: $limit) {
          items {
            ...ShNotificationFields
          }
          pageInfo {
            currentPage
            totalPages
            totalItems
            hasNextPage
            hasPreviousPage
          }
        }
      }
    }
  }
  ${SH_NOTIFICATION_FRAGMENT}
`;

export const GET_SH_NOTIFICATION_GROUP_COUNTS = gql`
  query GetShNotificationGroupCounts {
    MDB {
      id
      _SH_ {
        id
        notificationGroupCounts {
          groupKey
          unreadCount
          totalCount
        }
      }
    }
  }
`;

export const GET_SH_NOTIFICATION_UNREAD_COUNT = gql`
  query GetShNotificationUnreadCount {
    MDB {
      id
      _SH_ {
        id
        notificationUnreadCount
      }
    }
  }
`;

export const GET_SH_NOTIFICATION_CENTER_COUNT = gql`
  query GetShNotificationCenterCount {
    MDB {
      id
      _SH_ {
        id
        notificationCenterCount {
          unreadNotifications
          pendingAvailabilityRequestsAdditionalCount
          total
        }
      }
    }
  }
`;

export const MARK_SH_NOTIFICATION_READ = gql`
  mutation MarkShNotificationRead($id: ID!) {
    _SH_markNotificationRead(id: $id) {
      ...ShNotificationFields
    }
  }
  ${SH_NOTIFICATION_FRAGMENT}
`;

export const MARK_ALL_SH_NOTIFICATIONS_READ = gql`
  mutation MarkAllShNotificationsRead {
    _SH_markAllNotificationsRead
  }
`;

export const MARK_SH_NOTIFICATION_GROUP_READ = gql`
  mutation MarkShNotificationGroupRead($groupKey: _SH_NotificationGroupKey!) {
    _SH_markNotificationGroupRead(groupKey: $groupKey)
  }
`;

export const SH_NOTIFICATION_CREATED_SUBSCRIPTION = gql`
  subscription ShNotificationCreated {
    _SH_notificationCreated {
      ...ShNotificationFields
    }
  }
  ${SH_NOTIFICATION_FRAGMENT}
`;

export const GET_SH_PUBLIC_PLAYER_NOTIFICATIONS = gql`
  query GetShPublicPlayerNotifications(
    $token: String!
    $first: Int
    $after: String
    $unreadOnly: Boolean
  ) {
    _SH_publicPlayerNotifications(
      token: $token
      first: $first
      after: $after
      unreadOnly: $unreadOnly
    ) {
      items {
        ...ShPublicPlayerNotificationFields
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${SH_PUBLIC_PLAYER_NOTIFICATION_FRAGMENT}
`;

export const GET_SH_PUBLIC_PLAYER_NOTIFICATION_UNREAD_COUNT = gql`
  query GetShPublicPlayerNotificationUnreadCount($token: String!) {
    _SH_publicPlayerNotificationUnreadCount(token: $token)
  }
`;

export const MARK_SH_PUBLIC_PLAYER_NOTIFICATION_READ = gql`
  mutation MarkShPublicPlayerNotificationRead($token: String!, $id: ID!) {
    _SH_markPublicPlayerNotificationRead(token: $token, id: $id) {
      ...ShPublicPlayerNotificationFields
    }
  }
  ${SH_PUBLIC_PLAYER_NOTIFICATION_FRAGMENT}
`;

export const MARK_ALL_SH_PUBLIC_PLAYER_NOTIFICATIONS_READ = gql`
  mutation MarkAllShPublicPlayerNotificationsRead($token: String!) {
    _SH_markAllPublicPlayerNotificationsRead(token: $token)
  }
`;
